exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".SearchWindow_SearchWindow_1BTYe {\n    width: 100%;\n    margin: auto;\n}\n\n.SearchWindow_SearchWindow_1BTYe form div {\n    display: flex;\n    justify-content: left;\n    align-items: center;\n    flex-flow: row wrap;\n}\n\n.SearchWindow_FormTitle_3-Smo {\n    color: #337ab7;\n    margin: auto;\n    align-items: left;\n    padding-left: 10px;\n    display: flex;\n    flex-flow: row;\n    /*justify-content: right;*/\n}\n\n.SearchWindow_Message_3ce-i {\n    padding-left: 10px;\n}\n\n\n\n", ""]);

// Exports
exports.locals = {
	"SearchWindow": "SearchWindow_SearchWindow_1BTYe",
	"FormTitle": "SearchWindow_FormTitle_3-Smo",
	"Message": "SearchWindow_Message_3ce-i"
};